<template>
  <div class="hero">
    <div class="content">
      <h1 class="title">
        {{ title }}
      </h1>
      <p class="subtitle">
        {{ subtitle }}
      </p>

      <slot></slot>
    </div>

    <div
      v-if="showOverlay"
      class="overlay"
    ></div>
  </div>
</template>

<script>
export default {
  name: "Hero",
  props: {
    showOverlay: {
      type: Boolean,
      default: false
    },
    subtitle: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: "Emails for any occasion."
    }
  }
};
</script>

<style scoped>
.hero {
  @apply p-8 bg-grey-dark text-center relative;
  background: url("../../assets/images/heros/promo-pop.jpg") no-repeat;
  background-position: center 0;
  background-size: cover;

  @screen md {
    @apply py-10;
  }

  @screen lg {
    @apply py-12;
  }
}

.overlay {
  @apply absolute bg-white h-full w-full;
  background: rgb(0, 0, 0);
  background: linear-gradient(
    135deg,
    rgba(0, 0, 0, 1) 1%,
    rgba(57, 69, 138, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#000000', endColorstr='#39458a',GradientType=1 );
  left: 0;
  opacity: 0.05;
  top: 0;
}

.content {
  @apply relative;
  z-index: 1;
}

.title {
  @apply text-white text-xl font-black font-lato mb-0;
  text-shadow: 1px 1px 0 rgba(0, 0, 0, 0.2);
  transform: rotate(-0.3deg);

  @screen md {
    @apply text-2xl;
  }

  @screen lg {
    @apply text-4xl;
  }
}

.subtitle {
  @apply text-white text-xs font-normal font-sans mt-2 mb-0;
  text-shadow: 1px 1px 0 rgba(0, 0, 0, 0.2);
  transform: rotate(-0.3deg);
}
</style>
